import { Component } from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'

@Component({
  selector: 'hyperkit-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
})
export class NoticeComponent {}
